import { MAX_USERNAME_LENGTH, MAX_USER_PASSWORD_LENGTH } from '@ipfabric/utils';
import capitalize from 'lodash/capitalize';

export const authMessages = {
  en: {
    toasterMessages: {
      loginToContinue: 'Please login to continue',
    },
    form: {
      validation: {
        required: 'Required',
        smallPassword: 'Password must have at least 8 characters',
      },
      boxTitle: 'New username/password combination',
      button: {
        login: 'Log in',
        save: 'Save',
        signup: 'Sign up',
        forgotPassword: 'Forgot password',
      },
      legend: 'Log in to IP Fabric',
      label: {
        username: 'Username',
        password: 'Password',
        passwordRetype: 'Retype password',
        useInSyslog: 'Use for configuration management',
      },
      placeholder: {
        username: 'Username or nickname',
        password: 'password',
      },
      wrongPassword: 'Invalid login credentials',
      security: {
        title: 'UNAUTHORIZED ACCESS TO THIS SYSTEM IS PROHIBITED',
        content: (
          <>
            You must have explicit, authorized permission to access or configure
            this system.
            <br />
            Unauthorized attempts and actions to access or use this system may
            result in civil and/or criminal penalties.
            <br />
            All activities performed on this system are logged and monitored.
          </>
        ),
      },
    },
    logout: {
      button: 'Log out',
    },
    login: {
      title: 'Login',
    },
    validation: {
      password: 'Password must contain at least {minLength} characters.',
      passwordNotMach: 'Passwords do not match.',
      required: 'Field is required',
      passwordTooLong: `Password can contain at most ${MAX_USER_PASSWORD_LENGTH} characters`,
      usernameTooLong: `Password can contain at most ${MAX_USERNAME_LENGTH} characters`,
    },
    request: {
      outOfDiskSpaceTitle: 'Not enough disk space',
      outOfDiskSpaceMessage: '{space} of free space remaining',
    },
    singleSignOn: {
      loginWithIP: 'Or Log in with Identity Provider',
      notConfigured:
        'It seems your Organization has not configured Identity Provider yet.',
      howToSetup: 'How to setup IDP',
      continueWith: (name: string): string =>
        `Continue with ${capitalize(name)}`,
    },
    loggingOut: 'Logging out',
    eula: {
      title: 'IP FABRIC END USER LICENSE AGREEMENT',
      btnClose: 'Close',
    },
  },
};
